import React from 'react'

const EditContactDetailsContext = React.createContext()

export default EditContactDetailsContext
